module.exports = __webpack_public_path__ + "img/watkostdat@small.b3b1c5a8.png";